<template>
  <div class="card">    
    <div class="card-body ">
      <div class="mb-3">
      <div class="row">
        <div class="col-10">
          <div>
            <el-form  :model="filter" @submit.prevent="searchSubmit" >
              <div class="row">
                <div class="col-5">
                  <el-input
                    v-model="filter.search" 
                    placeholder="ค้นหาคำสั่งซื้อ|ทะเบียน|ชื่อ-ที่อยู่ลูกค้า [Enter]"
                    clearable 
                    :prefix-icon="searchIcon"
                  />
                </div>
                
                <el-button hidden native-type="submit" icon="el-icon-search"></el-button>
                <div class="col-4">
                  <date-time-picker-with-option style="width: 100%"  v-model="filter.dateRange" @change="searchSubmit"></date-time-picker-with-option>
                </div>
                           
              </div>
            </el-form>

          </div>
        </div>
        <div class="d-flex flex-row col-2 justify-content-end">         
          <button class="btn btn-sm btn-primary" @click="openDeliveryModal" :disabled="selectedOrder&&  selectedOrder.isComplete">
            <i class="fas fa-edit"></i>
             จัดรถ
          </button>
          <!-- &nbsp;&nbsp;
          <button class="btn btn-sm btn-dark-green" @click="openDeliveryModal">
            <i class="fas fa-check"></i>
             ยืนยันส่งสินค้า
          </button>-->
        </div>
      </div> 
    </div>
        <!-- @row-click="onRowClickHandeler" -->
    <div class="d-flex flex-row col justify-content-center">
      <el-table
        :data="orders"
        @current-change="onRowSelectHandler"     
        @row-dblclick="redirectToOrder2SDetail"   
        :height="windowHeight - 240"
        :width="100"
        highlight-current-row
        show-summary
        :summary-method="summary"
      >
        <el-table-column
          label="วันที่สั่งซื้อ"
          prop="created_at"
          width="100">
          <template #default="scope">
            {{ formatDateFromISO(scope.row.created_at) }}
          </template>
        </el-table-column>    
        <el-table-column
          label="คำสั่งซื้อ"
          prop="uoRefNo"
          width="130">
          <template #default="scope">
            <!-- <router-link
              v-if="isAdmin"
              :to="{name: 'partnerOrderDetail', params: {partnerCode: partnerCode, orderCode: scope.row.orderCode}}">
              <span class="fw-bolder text-primary" > {{scope.row.orderCode }}</span>
            </router-link> -->
              <!-- v-else -->
            <!-- <router-link
              :to="{name: 'orderDetail', params: {orderCode: scope.row.orderCode}}"> -->
              <p @click="redirectToOrder2SDetail" class="fw-bolder text-primary m-0" >#{{scope.row.uoRefNo }}</p>
              <span  @click="redirectToOrder2SDetail" > {{scope.row.receive_code }}</span>
            <!-- </router-link> -->
          </template>
        </el-table-column>
        <el-table-column
          label="การจัดส่ง"
          prop="delivery_method"
          width="130">
            <template  #default="scope">
              <span class="fw-bolder" v-if="scope.row.delivery_method.trim() == 'pickup'" >รับเอง</span>
              <span  class="fw-bolder" v-else >จัดส่ง </span> 
              <p  class="m-0" > {{ formatDateTimeFromISO(scope.row.partnerDeliveryDate) }}</p>
            </template>
        </el-table-column>   
        <el-table-column
          label="ทะเบียน"
          width="120">
          <template  #default="scope">
            <span v-if="scope.row.delivery_method.trim() != 'pickup'">
              {{scope.row.pnTruckCode}}
            </span>
            <span v-else>
              {{scope.row.cusTruckCode}}
            </span> &nbsp;
            <!-- <i class="fas fa-edit text-primary"></i>     -->
          </template>
        </el-table-column>     
        <!-- <el-table-column
          label="วันนัดรับสินค้า"
          prop="delivery_date"
          width="120">
          <template #default="scope">
            {{ formatDateFromISO(scope.row.delivery_date) }}
          </template>
        </el-table-column>         -->
        <el-table-column
          label="ลูกค้า"
          prop="cusname"
          width="150">
        </el-table-column>
        <el-table-column
          label="ที่อยู่"
          prop="delivery_address">
        </el-table-column>
        <!-- <el-table-column
          label="หมายเหตุ"
          prop="remark">
        </el-table-column> -->
        <el-table-column
          label="น้ำหนักรวม"
          prop="total_weight"
          width="100"
          align="right">          
          <template #default="scope">
            {{ numberWithCommas(scope.row.total_weight, 2) }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="true"
          label="จำนวนเงิน"
          prop="total_sell_price"
          align="right"
          width="120">
          <template #default="scope">
            {{ numberWithCommas(scope.row.total_sell_price, 2) }} 
          </template>
        </el-table-column>
        <el-table-column
          label="สถานะจัดรถ"
          align="center"
          width="100">
          <template #default="scope">
            <div v-if="scope.row.pnTruckCode || scope.row.cusTruckCode">
              <i class="fa fa-check-circle fa-lg icon-green "></i>
            </div>
          </template>
        </el-table-column>
        
      </el-table>
    </div>
    </div>
    <SetDeliveryDataModal ref="SetDeliveryDataModal" v-if="selectedOrder" :UORefNo="selectedOrder.uoRefNo" :Order="selectedOrder" @getOrderFn="getOrder"/>
  </div>
</template>

<script>
// import { reactive, ref } from "vue";
import ApiService from '../../core/services/ApiService';
import { numberWithCommas, formatDateFromISO, formatDateThDate,formatDateTimeFromISO } from "@/utils";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { DateTime } from 'luxon'
// import OrderStatus from '../../components/status/OrderStatus.vue';
import DateTimePickerWithOption from '../../components/forms/DateTimePickerWithOption.vue';
import { Calendar, Search } from '@element-plus/icons'
import { validateRole, role } from "@/helpers/role"
import SetDeliveryDataModal from '../../components/modals/forms/SetDeliveryDataModal.vue';

export default {
  components: {
    // OrderStatus,
    DateTimePickerWithOption,
    SetDeliveryDataModal
  },
  props: {
    partnerCode: String
  },
  data() {
    return {     
      partner: {},
      windowHeight: window.innerHeight,
      orders: [],
      loading: false,
      selectedOrder: null,
      filter: {
        search: null,
        status: [],
        dateRange: []
      },
      searchIcon: Search
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters.currentUser
    },
    isAdmin() {
      return this.currentUser.role == "Admin"
    },
  },
  created() {
    
    if(this.$route.query.startDate) {
      this.filter.dateRange[0] = new Date(this.$route.query.startDate)
      this.filter.dateRange[1] = new Date(this.$route.query.endDate)
    }
    else {
      
      var date = new Date(), y = date.getFullYear(), m = date.getMonth();
      
      this.filter.dateRange[0] = new Date(y, m, 1)
      this.filter.dateRange[1] = new Date(y, m + 1, 0)
    }

    if(window.localStorage.getItem('order2SFilter')){
      var temp = JSON.parse(window.localStorage.getItem('order2SFilter'));  
      temp.dateRange[0]= new Date(temp.dateRange[0]);
      temp.dateRange[1]= new Date(temp.dateRange[1]);  
      this.filter =temp;
      
    }
    window.localStorage.removeItem('order2SFilter');  
    
  },
  mounted() {
    this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.windowHeight = window.innerHeight
        });
    })
    
    setCurrentPageBreadcrumbs("คำสั่งซื้อ 2SOnline", [])
    
    if(this.partnerCode )
    {
      this.getPartner()
    }
    this.getOrder()
  },
  methods: {
    getPartner: async function() {
      const { data } = await ApiService.get("partners", this.partnerCode);
      this.partner = data
      setCurrentPageBreadcrumbs("รายการขาย" + this.partner.partnerName + " (" + this.partner.partnerCode + ")", ["รายงาน"])
    
    },
    getOrder() {
      this.loading = true;      
      this.selectedOrder = null

      let startDate
      let endDate
      // const status = this.status.find(s => s.name == this.filter.status)
      if(this.filter.dateRange ) {
        if(this.filter.dateRange[0] ) {
          // console.log(DateTime.fromJSDate (this.filter.dateRange[0]), this.filter.dateRange[0])
          startDate = DateTime.fromJSDate (this.filter.dateRange[0]).toFormat('yyyy-MM-dd')
        }
        if(this.filter.dateRange[1] ) {
          endDate = DateTime.fromJSDate (this.filter.dateRange[1]).toFormat('yyyy-MM-dd')
        }
      }
      let url = "orders/GetOrderFrom2SOnline"
      
      ApiService.query(
        url, 
        {
          params: {
            search: this.filter.search,
            startDate,
            endDate
          }
        })
        .then((res) => {
          this.orders = res.data
          //  console.log(this.orders);
        })
        .catch(err => {
          console.log(err)
        })
        .finally( () => {
          this.loading = false
          // this.selectedOrder = null
        })
      
    },
    
    onRowSelectHandler(row) {
      this.selectedOrder = row
      //this. getDeliveryOrder(row.uoRefNo);
    },
    getDeliveryOrder(uoRefNo) {
      this.isLoading = true;
      let url = "orders/GetDeliveryOrder2SOnline"
      
      ApiService.query(
        url, 
        {
          params: {
            uoRefNo:uoRefNo
          }
        })
        .then((res) => {
          // this.selectedOrder.truckID = res.data.truckID;
          // this.selectedOrder.partnerDeliveryDate = res.data.partnerDeliveryDate;
        })
        .catch(err => {
          console.log(err)
        })
        .finally( () => {
          this.loading = false
          // this.selectedOrder = null
        })
    },
    onRowClickHandler(row, column, event) {
      // this.$router.push({name: 'orderDetail', params: {orderCode: row.orderCode}})
      this.redirectToOrderDetail(row);
    },
    redirectToOrder2SDetail() { 
        window.localStorage.setItem('order2SFilter', JSON.stringify(this.filter));
        this.$router.push({name: 'order2SDetail', params: {uoRefNo: this.selectedOrder.uoRefNo}})
    },
    searchSubmit() {
      this.getOrder();
    }, 
    summary({columns, data}) {
      const sums = [];
      columns.forEach((col, index) => {
        if(index === 0) {
          sums[index] = data.length + ' รายการ';
        }


        const sumColumns = ['total_weight', 'total_sell_price']
        if(sumColumns.includes(col.property)) {
          sums[index] = numberWithCommas(data.reduce(
            (prev, curr) => {
              return prev + ( curr.canceled ? 0 : curr[col.property] )
            },
            0
          ))
        }


      })
      
        return sums;
    },
    openDeliveryModal(rowSelected){
      // this.selectedOrder=null;
      // this.selectedOrder = rowSelected;
      if(!this.selectedOrder){
        this.$message({
          type: "warning",
          message: "กรุณาเลือกอย่างน้อย 1 รายการ เพื่อบันทึกข้อมูลจัดส่ง",
        });  
        return;
      }
      setTimeout(() => {
          this.$refs.SetDeliveryDataModal.show();
      }, 500);
     
    },
    formatDateThDate,
    numberWithCommas,
    formatDateFromISO,
    formatDateTimeFromISO
  },
  
};
</script>
<style scoped>
.btn-green {
    color: #fff;
    background-color: #35a5b6;
    border-color: #117a8b;
}
.btn-dark-green {
    color: #fff;
    background-color: #066f8f;
}
.icon-green {
    color:  #117a8b;
}
</style>